import React, {ReactElement} from "react";
import {SelectDataset} from "../../components/main/header/SelectDataset";
import {SingleDropdownMenu} from "./SingleDropdownMenu";
import {useStores} from "../../stores";
import {FullMainMenu} from "./main-menus/FullMainMenu";
import {getAppEnvironment} from "../../routing/routing.utils";
import {useLocation, useParams} from "react-router";
import {SynergyV1Menu} from "./main-menus/SynergyV1Menu";
import {TaxonomyMergeMenu} from "./main-menus/TaxonomyMergeMenu";
import {DefaultMenu} from "./main-menus/DefaultMenu";

export const SingleHeader = () => {
    const {p} = useStores();
    const params = useParams();
    const location = useLocation();
    const appEnv = getAppEnvironment(location);

    let menu: ReactElement;
    let debug: string
    if (p.p.hide_main_menu) {
        menu = <></>;
        debug = 'hidden';
    } else {
        if (p.p.fullMenu) {
            menu = <FullMainMenu/>;
            debug = 'fullMenu';
        } else {
            debug = appEnv;
            switch (appEnv) {
                case 'synergy_v1':
                    menu = <SynergyV1Menu/>
                    break;
                case 'taxonomy_merge':
                    menu = <TaxonomyMergeMenu/>
                    break;
                case 'default':
                case 'pic':
                    menu = <DefaultMenu/>;
                    break;
                default:
                    menu = <></>;
                    debug = 'rest';
                    break;
            }
        }
    }

    return <>
        {menu}
        <div style={{flexGrow: 1}}/>
        <SelectDataset/>
        <SingleDropdownMenu/>
    </>;
}
